module.exports = __webpack_public_path__ + "assets/img/summary.227fde02.svg";